import { createBrowserHistory } from "history";
export default createBrowserHistory();

const getDefaultRoute = (permissions) => {
    if (permissions.includes('manage_shift')) {
      return '/orders';
    } else if (permissions.includes('edit_tables') || permissions.includes('view_tables')) {
      return '/tables';
    } else if (permissions.includes('edit_requests') || permissions.includes('view_requests')) {
      return '/requests';
    } else if (permissions.includes('take_payment')) {
      return '/cashier';
    }
    return '/profile';
};

export { getDefaultRoute };
